import React from 'react';
import classNames from 'classnames/bind';
import Title from "../../../../Title";
import { Growth } from "../../../../icons";
import { Markup } from "../../../../internal/Markup";
import { TextBase } from "../../../../internal/TextBase";
import { Highlighter } from '../Highlighter';
import { SubMenuLinkList } from '../SubMenuLink/SubMenuLinkList';
import styles from './SearchLink.css';
var cx = classNames.bind(styles);
export var SearchLink = function SearchLink(_ref) {
  var href = _ref.href,
      target = _ref.target,
      title = _ref.title,
      showIcon = _ref.showIcon,
      onClick = _ref.onClick,
      searchValue = _ref.searchValue,
      theme = _ref.theme,
      points = _ref.points;

  var RenderLink = function RenderLink() {
    return /*#__PURE__*/React.createElement("a", {
      className: cx('root', "theme_".concat(theme)),
      href: href,
      onClick: onClick,
      target: target
    }, /*#__PURE__*/React.createElement(TextBase, {
      as: "span",
      color: "N100",
      size: "l",
      display: "flex"
    }, searchValue ? /*#__PURE__*/React.createElement(Highlighter, {
      text: title,
      highlight: searchValue
    }) : /*#__PURE__*/React.createElement(Markup, {
      text: title || ''
    }), showIcon && /*#__PURE__*/React.createElement("span", {
      className: cx('new_window')
    }, /*#__PURE__*/React.createElement(Growth, {
      width: 12
    }))));
  };

  var RenderLinkList = function RenderLinkList() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, {
      level: 5,
      as: "p"
    }, searchValue ? /*#__PURE__*/React.createElement(Highlighter, {
      text: title,
      highlight: searchValue
    }) : /*#__PURE__*/React.createElement(Markup, {
      text: title || ''
    })), /*#__PURE__*/React.createElement(SubMenuLinkList, {
      points: points,
      onClick: onClick,
      searchValue: searchValue,
      showIcon: showIcon,
      target: target,
      theme: theme
    }));
  };

  return points !== null && points !== void 0 && points.length ? /*#__PURE__*/React.createElement(RenderLinkList, null) : /*#__PURE__*/React.createElement(RenderLink, null);
};